<div class="grid-container padding-y-4">
    <form id="ratesSroMaintenanceSearchGroup" role="form" [formGroup]="ratesSroMaintenanceSearchGroup">
        <div class="grid-row">
            <h3 class="usa-legend usa-legend--large">Define HHG SRO</h3>
        </div>
        <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label aria-label="SRO" class="usa-label">SRO<abbr title="required"
                                                           class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" placeholder="Enter SRO ID to Search and hit Enter" id="sro" class="usa-input maxw-full" formControlName='sroSearch' [typeahead]="sroIDList" [typeaheadMinLength]="1" [typeaheadOptionsLimit]="10" [maxlength]="10" oninput="this.value = this.value.toUpperCase()"
                    (keyup.enter)="onSroSearch($event.target.value)">
            </div>

        </div>

        <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="search-agency-name" class="usa-label">Agency Name<abbr title="required"
                                                                           class="usa-hint usa-hint--required">*</abbr></label>
                <ng-template #agencySearchTemplate let-model="item" let-index="index">
                    {{model.agencyBureauName}} - {{model.agencyCode}}
                </ng-template>
                <input id="search-agency-name" class="usa-input maxw-full" formControlName='agencyName' placeholder="Search Agency" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0" (typeaheadOnSelect)="onAgencyNameChange($event)"
                    typeaheadOptionField="agencyBureauName" [typeahead]="agencyCustomerList" [typeaheadItemTemplate]="agencySearchTemplate" [typeaheadScrollable]="true">
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro_bureau" class="usa-label">Bureau Name</label>
                <select id="sro_bureau" class="usa-select  maxw-full" formControlName="bureauName" (change)="onBureauChange($event.target.value)">
          <option hidden value='null'>Choose</option>
          <option *ngFor="let bureau of agencyBureauList" [value]="bureau.bureauCode">
            {{bureau.agencyBureauName}} -
            {{bureau.bureauCode}}
          </option>
        </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro_location" class="usa-label">Location</label>
                <select id="sro_location" class="usa-select maxw-full" formControlName="agencyBureauLocation" (change)="sroListByAgencyIdAndLocation($event.target.value)">
          <option value="">None</option>
          <option *ngFor="let agencyBureauDet of agencyBureauData" [value]="agencyBureauDet.agencyId">
            {{agencyBureauDet.agencyLocation}} ({{agencyBureauDet.organizationId}} - {{agencyBureauDet.contactName}})
          </option>
        </select>
            </div>
        </div>
        <hr>
        <div class="grid-row">
            <h3 class="usa-legend usa-legend--medium">Information</h3>
        </div>

        <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro_route_order" class="usa-label">Standing Route Order<abbr title="required"
                                                                                 class="usa-hint usa-hint--required">*</abbr></label>
                <select id="sro_route_order" class="usa-select maxw-full" formControlName="sroCode" (change)="onSroChange($event.target.value)">
          <option hidden value='null'>Choose</option>
          <option *ngFor="let sro of sroList" [value]="sro.sroId"> {{sro.sroId}} </option>
        </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro_effective_date" class="usa-label">SRO Effective Date<abbr title="required"
                                                                                  class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="sro_effective_date" class="usa-input" maxw-full formControlName="effectiveDate" placeholder="mm/dd/yyyy" bsDatepicker [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label class="usa-label" for="sro_expiration_date">SRO Expiration Date</label>
                <input type="text" id="sro_expiration_date" class="usa-input maxw-full" formControlName="expiryDate" placeholder="mm/dd/yyyy" bsDatepicker [minDate]="minExpiryDate" [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
            </div>
        </div>

        <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                <label for="sro_rate_type" class="usa-label">SRO Type<abbr title="required"
                                                                   class="usa-hint usa-hint--required">*</abbr></label>
                <select id="sro_rate_type" class="usa-select maxw-full" formControlName="sroType" (change)="onSroTypeChange($event.target.value)">
          <option hidden value='null'>Choose</option>
          <option *ngFor="let srotype of sroTypes">{{srotype}}</option>
        </select>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
                <div class="grid-row grid-gap-2">
                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                        <label for="rate_type" class="usa-label">Available Rate Types</label>
                        <select multiple id="rate_type" class="define-height-usa-select  usa-select maxw-full" formControlName="rateType" title="Available Rate Types" name="RateTypeList" aria-label="Select from available rate types">
              <option value='null'>-Select Rate Type(s)-</option>
              <option *ngFor="let rateType of availRateTypesArray" [value]="rateType.rateTypeId">
                {{rateType.rateTypeId}} - {{rateType.description}}
              </option>
            </select>
                    </div>

                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 text-center define-margin-x-y-auto">
                        <button type="button" class="usa-button usa-button--hover width-full" (click)="moveItems()">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
                            </svg>
            </button>
                    </div>

                    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
                        <label for="assigned_rate_type" class="usa-label">Assigned Rate Types</label>
                        <select multiple id="assigned_rate_type" formControlName="assignedrateType" class="define-height-usa-select  usa-select maxw-full">
                            <option *ngFor="let assignedRateType of assignedRateTypes; let i = index"
                                    [value]="assignedRateType.legacyRateType"
                                    (dblclick)="handleRateTypesMultiDropdown(i)">
                                {{assignedRateType.legacyRateType}} - {{assignedRateType.description}}
                            </option>
                        </select>
                        <div style="font-weight: 700;">Double click on item to remove from this list.</div>
                    </div>
                </div>
            </div>

        </div>

        <div class="grid-row grid-gap-2">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <label for="sro_notes" class="usa-label">Notes</label>
                <textarea id="sro_notes" class="usa-textarea maxw-full" formControlName="sroNotes"></textarea>
            </div>
        </div>

        <hr>
        <div class="grid-row grid-gap-2">
            <div class="grid-col-10">
                <legend class="usa-legend usa-legend--medium">Lanes</legend>
            </div>
            <div class="grid-col-2 float-right margin-top-2 text-right">
                <button type="button" class="usa-button" (click)="[addModal.show(), addOrigDestLanes()]">Add
        </button>
            </div>
        </div>
        <ag-grid-angular class="ag-theme-alpine" [gridOptions]="gridOptions"
                         [animateRows]="true"
                         [rowData]="origDestDetails"
                         [components]="frameworkComponents"
                         (gridReady)="onGridReady($event)">
        </ag-grid-angular>

        <div class="grid-row grid-gap-2">
            <button type="button" class="usa-button" type="button" [disabled]="!this.ratesSroMaintenanceSearchGroup.valid" (click)="sroFormSave()">Save
      </button>
            <button type="button" class="usa-button usa-button--secondary" (click)="clearFormAll()">Reset
      </button>
          <button type="button" class="usa-button usa-button--secondary" *ngIf="deleteSroButton" (click)="deleteSro()">Delete SRO
          </button>
        </div>
    </form>
</div>

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="add-origin-destination">
    <div class="usa-modal usa-modal--lg display-flex" id="example-modal-2" aria-labelledby="modal-2-heading" aria-describedby="modal-2-description">
        <div class="usa-modal__content">
            <div class="usa-modal__main padding-y-0 define-width">
                <h2 class="usa-modal__heading" id="modal-2-heading">
                    Add Origin/Destination
                </h2>
                <div class="usa-prose">
                    <form id="ratesSroMaintenanceAddGroup" role="form" [formGroup]="ratesSroMaintenanceAddGroup">
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_zone">Origin Country</label>
                                <select multiple id="sro_zone" class="maxw-full usa-select define-height-usa-select" formControlName="addOriginCountry">
                    <option value="AllCountries">Check All Countries</option>
                    <option *ngFor="let country of allCountriesList" [value]="country.stateCountryId">
                      {{country.stateCountryName}}
                    </option>
                  </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_dest_zone">Destination Country</label>
                            <select multiple id="sro_dest_zone" class="maxw-full usa-select define-height-usa-select" formControlName="addDestinationCountry">
                <option value="AllCountries">Check All Countries</option>
                <option *ngFor="let country of allCountriesList" [value]="country.stateCountryId">
                  {{country.stateCountryName}}
                </option>
              </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_zone">Origin State</label>
                                <select multiple id="sro_zone" class="maxw-full usa-select define-height-usa-select" formControlName="addOriginState">
                    <option value="AllStates">Check All CONUS States</option>
                    <option *ngFor="let state of allStatesList" [value]="state.stateCountryId">
                      {{state.stateCountryName}}
                    </option>
                  </select>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                                <label class="usa-label" for="sro_dest_zone">Destination State</label>
                            <select multiple id="sro_dest_zone" class="maxw-full usa-select define-height-usa-select" formControlName="addDestinationState">
                <option value="AllStates">Check All CONUS States</option>
                <option *ngFor="let state of allStatesList" [value]="state.stateCountryId">
                  {{state.stateCountryName}}
                </option>
              </select>
                            </div>

                        </div>
                        <div class="grid-row grid-gap">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="showAddress">
                                <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}} , {{model.zipCode}}
                                </ng-template>
                                <label class="usa-label" for="origin">Origin Address</label>
                                <input id="origin" class="maxw-full usa-input" formControlName="asyncOriginSearchString" [typeaheadAsync]="true"
                                    [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
                                    (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" typeaheadOptionField="cityName"
                                    [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
                                    [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100"
                                    placeholder="Enter a location or zip code">
                                <div class="is-loading" role="status" *ngIf="typeaheadLoading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="text-secondary"
                                    *ngIf="this.ratesSroMaintenanceAddGroup.get('originId').touched && this.ratesSroMaintenanceAddGroup.get('originId').hasError('required')">
                                    <span class="fa fa-warning"></span> Destination is required
                                </div>
                                <label class="usa-label define-bottom-tag" *ngIf="ratesSroMaintenanceAddGroup.value.originId">
                                    {{ratesSroMaintenanceAddGroup.value.originId?.cityName}},
                                    {{ratesSroMaintenanceAddGroup.value.originId?.stateAbbrev}}
                                    {{ratesSroMaintenanceAddGroup.value.originId?.zipCode}}
                                </label>
                            </div>

                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" *ngIf="showAddress">
                                <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}}, {{model.zipCode}}
                                </ng-template>
                                <label class="usa-label" for="destination">Destination</label>
                                <input id="destination" class="maxw-full usa-input" formControlName="asyncDestinationSearchString" [typeaheadAsync]="true" [typeahead]="dataSourceDestination" (typeaheadLoading)="changeTypeaheadDestinationLoading($event)" (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)"
                                    typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" placeholder="Enter a location or zip code">
                                <div class="is-loading" role="status" *ngIf="typeaheadLoading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div class="text-secondary" *ngIf="this.ratesSroMaintenanceAddGroup.get('destinationId').touched && this.ratesSroMaintenanceAddGroup.get('destinationId').hasError('required')">
                                    <span class="fa fa-warning"></span> Destination is required
                                </div>
                                <label class="usa-label define-bottom-tag" *ngIf="ratesSroMaintenanceAddGroup.value.destinationId">
                                    {{ratesSroMaintenanceAddGroup.value.destinationId?.cityName}}, {{ratesSroMaintenanceAddGroup.value.destinationId?.stateAbbrev}} {{ratesSroMaintenanceAddGroup.value.destinationId?.zipCode}}
                                </label>
                            </div>
                        </div>

                        <div class="grid-row grid-gap padding-top-4">
                            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" >
                                <button type="button" class="usa-button" [disabled]="(
                (this.ratesSroMaintenanceAddGroup.get('addOriginCountry').value===null &&
                this.ratesSroMaintenanceAddGroup.get('addOriginState').value===null &&
                this.ratesSroMaintenanceAddGroup.get('asyncOriginSearchString').value===null ) ||
                (this.ratesSroMaintenanceAddGroup.get('addDestinationCountry').value===null &&
                this.ratesSroMaintenanceAddGroup.get('addDestinationState').value===null &&
                this.ratesSroMaintenanceAddGroup.get('asyncDestinationSearchString').value===null))" (click)="[addOriginDestination(), addModal.hide()]">Add
            </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="addModal.hide()" data-close-modal>
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>
</div>
